import React, { FC, useEffect } from "react";

import { BillingCenterHistoryItem } from "@app/postBill/components/billingCenterHistory";
import { BillingCenterHistoryItemTypes } from "@app/postBill/components/billingCenterHistory/billingCenterHistoryItem/billingCenterHistoryItem";
import { usePostBillHeapEvent } from "@app/postBill/hooks";

import "./billingCenterHistory.scss";
import { HEAP_EVENTS } from "@app/provider/types";

const BillingCenterHistory: FC = () => {
  const { trackPostBillHeapEvent } = usePostBillHeapEvent();

  useEffect(() => {
    trackPostBillHeapEvent({
      eventKey: HEAP_EVENTS.upp_view_billing_history_tab,
    });
  }, []);

  return (
    <div className="billing-center-history">
      <div className="billing-center-history__list">
        <BillingCenterHistoryItem
          type={BillingCenterHistoryItemTypes.PAYMENTS}
        />
        <BillingCenterHistoryItem
          type={BillingCenterHistoryItemTypes.STATEMENTS}
        />
        <BillingCenterHistoryItem
          type={BillingCenterHistoryItemTypes.PAYMENT_PLANS}
        />
      </div>
    </div>
  );
};

export default BillingCenterHistory;
